import {match} from 'ts-pattern';

import {FinancialProductOffer} from '../../../api/types/onlineOfferTypes';

/**
 * A product unavailable on stored coordinates keeps its tab and controls because moving
 * onto a remaining dimension is the way out; it loses them only if a priced dimension is empty.
 */
export const hasChoosableConfiguration = (offer: FinancialProductOffer) =>
  match(offer.productType)
    .with(
      'LEASING',
      () => offer.availableLeasingCells.length > 0 && offer.availableTargetGroups.length > 0
    )
    .with(
      'BALLOON',
      () =>
        offer.availableTerms.length > 0 &&
        offer.availableDownPaymentPercentages.length > 0 &&
        offer.availableBalloonPaymentPercentages.length > 0
    )
    .with(
      'STANDARD',
      () => offer.availableTerms.length > 0 && offer.availableDownPaymentPercentages.length > 0
    )
    .exhaustive();
